export default {"src":"/_next/static/media/russetpotato.eccfe487.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};